import SafetyService from '@/services/safety.service';
import instance from "@/http";
import { httpClient } from "@/services";

function getFilters(data) {
	return Object.keys(data).reduce((acc, item) => {
		if (item.includes('filter')) {
			acc[item] = data[item];
		}

		return acc;
	}, {});
}

export default {
	state: {
		employees: [],
		safetyCustomers: [],
		driverActions: [],
		filters: null
	},
	getters: {
		employees: s => s.employees,
		filters: s => s.filters,
		safetyCustomers: s => s.safetyCustomers,
		driverActions: s => s.driverActions
	},
	mutations: {
		deleteAction(state, payload) {
			state.driverActions.list.map(action => action.id === payload.id && (action.status = 0));
		},
		updateDriverActions(state, payload) {
			payload && (state.driverActions = payload);
		},
		updateSafetyCalendar(state, payload) {
			const { employees, customers } = payload;
			state.filters = getFilters(payload);
			state.employees = employees;
			state.safetyCustomers = customers;
		},
		updateSafetyStatus(state, payload) {
			state.safetyStatus = payload;
		},
		updateSafetyHours(state, payload) {
			state.safetyDrivingHours = payload;
		},
	},
	actions: {
		async deleteDriverAction({ commit, dispatch }, payload) {
			const { driver_id } = payload;
			const driver_date = payload.date;

			try {
				const { data } = await httpClient.post(`/safety/${ driver_id }/${ driver_date }`, payload);

				if (data && data.status) {
					commit('updateDriverActions', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onDriverActions({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			const { id, date } = payload;
			try {
				const { data } = await httpClient.get(`/safety/${ id }/${ date }`);

				if (data && data.status) {
					commit('updateDriverActions', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async safetyCalendar({ commit, dispatch }, data) {
			dispatch("actionPreloader", true);
			try {
				const result = await httpClient.post('/safety/list', { data });
				if (result.data.status) {
					commit('updateSafetyCalendar', result.data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onUpdateSafetyRow(context, payload) {
			return await SafetyService.setSafetyCalendar(payload).then(result => {
				return result;
			});
		},
		async addSafetyStatus({ commit }, payload) {
			return await SafetyService.updateSafetyStatus(payload).then(result => {
				if (result.status) {
					commit('updateSafetyStatus', result.safety_status);
				}
			});
		},
		async addSafetyHours({ commit }, payload) {
			return await SafetyService.updateSafetyHours(payload).then(result => {
				if (result.status) {
					commit('updateSafetyHours', result['safety_driving_hours']);
				}
			});
		},
		async onCreateSafetyReports(context, values) {
			try {
				return instance().post('/reports/safety/create', values);
			} catch (e) {
				console.info(e);
			}
		},
		async onExportSafetyReports(context, values) {
			try {
				return instance().post('safety/export', values);
			} catch (e) {
				console.info(e);
			}
		},
		async onSentSafetyReports(context, values) {
			try {
				return instance().post('/reports/safety', values);
			} catch (e) {
				console.info(e);
			}
		},
	}
};
